import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, BrowserEvents, Classes, Elements, TransitionDurations } from '../global/constants';
import { scrollToElement } from '../global/helpers';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 75%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

		Animations.mobile.min.push(() => {

			const image = this.querySelector(':scope .section-image');
			const speed = 25;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
			}
		});
	});

	$('.manifest-section').each(function() {

		Animations.global.push(() => {

			ScrollTrigger.create({
				trigger: this,
				start: () => `top top+=${$Elements.HeaderWrapper.height()}`,
				end: () => `+=${(window.innerHeight - $Elements.HeaderWrapper.height()) + $(this).find('.section-content').height()}`,
				toggleClass: {
					className: 'inverted',
					targets: Elements.MenuWrapper
				}
			});

			ScrollTrigger.create({
				trigger: this,
				start: 'top 80%',
				end: 'bottom 20%',
				onEnter: () => scrollToElement(this),
				onEnterBack: () => scrollToElement(this),
			});
		});
	});

	$('.header-text-image-section, .multiple-text-image-section').each(function() {

		Animations.md.min.push(() => {

			const content = this.querySelectorAll(':scope .text-column');

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
			});

			if(content) {
				timeline.to(content, { y: '25vh', ease: 'none' });
			}
		});
	});

	$('.simple-text-section').each(function() {

		Animations.md.min.push(() => {

			const content = this.querySelectorAll(':scope .text-column');

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
			});

			if(content) {
				timeline.to(content, { y: '20vh', ease: 'none' });
			}
		});
	});

	$('.green-text-image-section, .whiskies-section').each(function() {

		Animations.md.min.push(() => {

			const content = this.querySelectorAll(':scope .image-column');

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
			});

			if(content) {
				timeline.to(content, { y: '-30vh', ease: 'none' });
			}
		});
	});
};

$Elements.document.on(BrowserEvents.page.enter, () => initScrollAnimations());
